export default __webpack_public_path__ + "static/media/woodfloormiddle.ca71501e.jpg";